import { scrollToTop } from '@applyonline/shared/utils'
import { EApplicantType } from '@if/core/types'
import { useLayoutEffect } from 'react'
import { Route, Routes } from 'react-router-dom'

import { FilteredCreditApplication, RequiredDocumentWithStatus } from '@applyonline/shared'
import ApplicantVoidChequePage from './components/ApplicantVoidChequePage'
import CustomerFeedbackPage from './components/CustomerFeedbackPage'
import DocumentsPage from './components/DocumentsPage'
import OverviewPage from './OverviewPage/OverviewPage'

interface Props {
  creditApp: FilteredCreditApplication
  skipBankAccountRequiredDocuments: RequiredDocumentWithStatus[]
}

const HardHitApprovedResultPage = ({ creditApp, skipBankAccountRequiredDocuments }: Props) => {
  useLayoutEffect(scrollToTop, [])

  return (
    <Routes>
      <Route
        path="applicant-incomes"
        element={<ApplicantVoidChequePage creditApp={creditApp} applicantType={EApplicantType.Applicant} />}
      />
      <Route path="required-documents" element={<DocumentsPage creditApp={creditApp} />} />

      <Route path="feed-back" element={<CustomerFeedbackPage creditApp={creditApp} />} />

      <Route
        index
        path="*"
        element={
          <OverviewPage creditApp={creditApp} skipBankAccountRequiredDocuments={skipBankAccountRequiredDocuments} />
        }
      />
    </Routes>
  )
}

export default HardHitApprovedResultPage
